import { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import Article from './index';
import { dateFormatUK } from '../../../utils/commonFunctions';

class ArticleList extends Component {
  render() {
    const { type } = this.props;
    let currentColor = -1;

    return (
      <div className="article-list">
        {this.props.articles.map((key) => {
          currentColor += 1;
          currentColor %= 4;

          return (
            <Col key={key.id} lg={4} md={6} sm={12} xs={12}>
              <Article
                color={currentColor}
                date={dateFormatUK(key.attributes['display-from-date'])}
                featured={key.attributes.featured}
                id={key.id}
                image={key.attributes.link.image}
                key={key.id}
                title={key.attributes.title}
                type={type}
                category={key.attributes.category}
              />
            </Col>
          );
        })}
      </div>
    );
  }
}

ArticleList.propTypes = {
  articles: PropTypes.array.isRequired
};

export default ArticleList;
